import React from 'react';
import {getBackgroundImg, getPublicImagePath, MarkupRender, useAppState} from "@nutastic/nutastic-react-app";

const ComingSoonPage = () => {
    const {
        pageTitle,
        pageText
    } = useAppState();
    const componentClass = 'coming-soon-page'; //uses the styles from home page
    const bannerStyle = getBackgroundImg(getPublicImagePath('homeImage.jpg'));

    return <section className={`${componentClass}__hero-banner`}>
        <div className="slideshow" style={bannerStyle} />
        <div className="hero-text">
            <h1>{ pageTitle }</h1>
            <MarkupRender content={pageText} />
        </div>
    </section>;
};

export default ComingSoonPage;
